
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/webaccessibilitychecklist",
      function () {
        return require("private-next-pages/download/webaccessibilitychecklist/index.tsx");
      }
    ]);
  